import i18n from "../utils/i18n/i18n";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";

const SkeletonBlock = ({ className = "" }) => (
  <div
    className={`relative overflow-hidden rounded-md bg-slate-200/80 ${className}`}
  >
    <div
      className="absolute inset-0 -translate-x-full animate-[cargando-shimmer_1.4s_ease-in-out_infinite]"
      style={{
        background: `linear-gradient(90deg, transparent, ${COLOR_AZUL_MAIN}22, transparent)`,
      }}
    />
  </div>
);

const SkeletonRow = () => (
  <div className="flex items-center gap-3 border-b border-slate-100 px-4 py-3 last:border-b-0">
    <SkeletonBlock className="h-9 w-9 shrink-0 rounded-full" />
    <div className="min-w-0 flex-1 space-y-2">
      <SkeletonBlock className="h-3.5 w-[55%]" />
      <SkeletonBlock className="h-3 w-[35%]" />
    </div>
    <SkeletonBlock className="hidden h-8 w-20 shrink-0 sm:block" />
  </div>
);

/**
 * Skeleton loading card shown while fetching data from the server.
 * Compatible with both `cargandoCard()` and `<CargandoCard />`.
 */
const CargandoCard = () => {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 lg:px-6">
      <style>{`
        @keyframes cargando-shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>

      <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="space-y-2">
          <SkeletonBlock className="h-7 w-48 sm:w-64" />
          <SkeletonBlock className="h-3.5 w-64 sm:w-80" />
        </div>
        <SkeletonBlock className="h-10 w-28 rounded-lg" />
      </div>

      <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <SkeletonBlock className="h-10 w-full rounded-lg" />
        <SkeletonBlock className="h-10 w-full rounded-lg" />
        <SkeletonBlock className="h-10 w-full rounded-lg" />
        <SkeletonBlock className="h-10 w-full rounded-lg" />
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <div
          className="flex items-center gap-2 border-b px-4 py-3"
          style={{
            borderColor: `${COLOR_AZUL_MAIN}22`,
            backgroundColor: `${COLOR_AZUL_MAIN}08`,
          }}
        >
          <div
            className="h-2 w-2 animate-pulse rounded-full"
            style={{ backgroundColor: COLOR_AZUL_MAIN }}
          />
          <p className="text-sm font-medium" style={{ color: COLOR_AZUL_MAIN }}>
            {i18n.t("label_cargando_informacion")}…
          </p>
        </div>

        <div className="hidden border-b border-slate-100 bg-slate-50/80 px-4 py-3 sm:grid sm:grid-cols-12 sm:gap-3">
          <SkeletonBlock className="col-span-3 h-3" />
          <SkeletonBlock className="col-span-3 h-3" />
          <SkeletonBlock className="col-span-3 h-3" />
          <SkeletonBlock className="col-span-3 h-3" />
        </div>

        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
        <SkeletonRow />
      </div>

      <div className="mt-4 flex items-center justify-between">
        <SkeletonBlock className="h-3.5 w-28" />
        <div className="flex gap-2">
          <SkeletonBlock className="h-8 w-8 rounded-md" />
          <SkeletonBlock className="h-8 w-8 rounded-md" />
          <SkeletonBlock className="h-8 w-8 rounded-md" />
        </div>
      </div>
    </div>
  );
};

export default CargandoCard;
